import React from 'react';
import {Modal, Button} from 'react-bootstrap';

function YesNoModal(props){

    return (
        <Modal
            show={props.show}
            onHide={props.handleClose}
            backdrop="static"
            keyboard={false}
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Oznámení
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                {props.text}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.handleClose} variant="secondary">Ne</Button>
                <Button onClick={props.handleContinue} variant="primary">Ano</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default YesNoModal;